













































































import Vue from 'vue';
export default Vue.extend({
  name: 'ContributionsBar',
  props: {
    /**
     * This is the amount the bar will be filled
     */
    currentAmount: {
      type: [Number, String],
      default: 0,
    },
    currentAmountLabel: {
      type: String,
      default: '',
    },
    min: {
      type: [Number, String],
      default: 0,
    },
    minLabel: {
      type: String,
      default: '',
    },
    max: {
      type: [Number, String],
      default: 7750,
    },
    maxLabel: {
      type: String,
      default: '',
    },
    secondMarkerValue: {
      type: [Number, String],
      default: 0,
    },
    firstMarkerValue: {
      type: [Number, String],
      default: 0,
    },
    firstMarkerLabel: {
      type: String,
      default: '',
    },
    secondMarkerLabel: {
      type: String,
      default: '',
    },
    currentAmountNegative: {
      type: Boolean,
      default: false,
    },
    firstMarkerLeft: {
      type: Boolean,
      default: false,
    },
    secondMarkerLeft: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    valuePercentage(): number {
      return (parseInt(this.currentAmount as string) / parseInt(this.max as string)) * 100;
    },
    firstMarkerPosition(): number {
      return (parseInt(this.firstMarkerValue as string) / parseInt(this.max as string)) * 100;
    },
    secondMarkerPosition(): number {
      return (parseInt(this.secondMarkerValue as string) / parseInt(this.max as string)) * 100;
    },
  },
});
